import moment from "moment";
import React, { useState, useEffect } from "react";
import Button from "../../../components/Button";
import InputDate from "../../../components/InputDate";
import InputSelect from "../../../components/InputSelect";
import Modal from "../../../components/Modal";
import { createOptions } from "../../../helpers/selects";
import api from "../../../services/api";

const proposalOptions = [
    { label: 'Todos', value: null },
    { label: 'Sem proposta gerada', value: 'missing' },
    { label: 'Com proposta gerada', value: 'generated' },
];

export const ModalFilter = ({showFilter, setShowFilter, setCustomFilters, filters, brandOptions = []}) => {
    const [admins, setAdmins] = useState([]);
    const [admin, setAdmin] = useState(null);
    const [brand, setBrand] = useState(null);
    const [initDate, setInitDate] = useState(null);
    const [finalDate, setFinalDate] = useState(null);
    const [proposal, setProposal] = useState(null);

    useEffect(() => {
        getAdmins();
    }, []);

    useEffect(() => {
        if (!showFilter) return;

        setAdmin(filters.adminId);
        setBrand(brandOptions.find(option => String(option.value) === String(filters.brand))?.value ?? null);
        setInitDate(filters.createdFrom ? moment(filters.createdFrom).format('YYYY-MM-DD') : null);
        setFinalDate(filters.createdTo ? moment(filters.createdTo).format('YYYY-MM-DD') : null);
        setProposal(filters.proposal);
    }, [showFilter, filters, brandOptions]);

    const getAdmins = () => {
        api.get(`/list`).then(res => {
            setAdmins(res.data.resources);
        });
    }
    
    const handleClear = () => {
        setCustomFilters({
            brand: null,
            adminId: null,
            createdFrom: null,
            createdTo: null,
            proposal: null,
            proposalCreatedFrom: null,
            proposalCreatedTo: null,
        });
        setAdmin(null);
        setBrand(null);
        setInitDate(null);
        setFinalDate(null);
        setProposal(null);
        setShowFilter(false);
    }

    const handleFilter = () => {
        const keepProposalDates = proposal === filters.proposal;

        setCustomFilters({
            brand,
            adminId: admin,
            createdFrom: initDate ? moment(initDate).format('YYYY-MM-DD') : null,
            createdTo: finalDate ? moment(finalDate).format('YYYY-MM-DD') : null,
            proposal,
            proposalCreatedFrom: keepProposalDates ? filters.proposalCreatedFrom : null,
            proposalCreatedTo: keepProposalDates ? filters.proposalCreatedTo : null,
        });
        setShowFilter(false);
    }
    
    return (
        <Modal
            show={showFilter}
            close={() => setShowFilter(false)}
            title={`Filtrar`}
            footer={
                <>
                    <Button
                        type={`secondary`}
                        size={`small`}
                        text={`Limpar filtros`}
                        action={handleClear}
                    />
                    <Button
                        type={`primary`}
                        size={`small`}
                        text={`Filtrar resultados`}
                        action={handleFilter}
                    />
                    
                </>
            }
        >
            <div className="section">
                <div className="row">
                    <div className="col">
                        <InputSelect label={`Responsável`} options={createOptions(admins, 'name', 'id', true, null, 'Todos')} value={admin} change={setAdmin} />
                    </div>
                </div>
                {brandOptions.length > 0 &&
                    <div className="row">
                        <div className="col">
                            <InputSelect label={`Marca`} options={brandOptions} value={brand} change={setBrand} />
                        </div>
                    </div>
                }
                <div className="row">
                    <div className="col">
                        <InputSelect label={`Proposta`} options={proposalOptions} value={proposal} change={setProposal} />
                    </div>
                </div>
                <div className="row">
                    <div className="col-6">
                        <InputDate
                            value={initDate}
                            change={setInitDate}
                            label={`Data inicial`}
                        />
                    </div>
                    <div className="col-6">
                        <InputDate
                            value={finalDate}
                            change={setFinalDate}
                            label={`Data final`}
                        />
                    </div>
                </div>
            </div>
        </Modal>
    )
}
